import React, { useEffect } from "react";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";

const PassesColorPage: React.FC = () => {
  const { colorGroup, requestGetColorGroups } = useTickets();

  useEffect(() => {
    requestGetColorGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="container">
        {colorGroup && (
          <div className="limited-ticket-wrapper">
            {colorGroup.map((item, index) => (
              <LimitedTicketBlock item={item} sortType="colorGroupPasses" key={index} />
            ))}
          </div>
        )}
        <div></div>
      </div>
    </>
  );
};

export default PassesColorPage;
